import useLocale from '@/client/hooks/use-locale';
import { formatDate } from '@/client/utils/format';
import { Time } from 'lightweight-charts';

type FormatDateProps = {
  time: Time | Date;
  formatStr?: string;
};
export const FormatDate = ({ time, formatStr }: FormatDateProps) => {
  const { locale } = useLocale();
  return formatDate(time, locale, formatStr);
};
